import React from 'react';
import { navigate,url } from 'js/services/Network';
import AppUser from 'js/stores/AppUser';
import AppContent from 'js/components/AppContent';
import PageComponent from 'js/components/pages/PageComponent';
import Constraint from 'js/components/Constraint';
import AppState from "js/stores/AppState";
import { AvForm, AvGroup, AvInput, AvFeedback } from 'availity-mobx-reactstrap-validation';
import Button from 'js/components/common/Button';
import FormState from 'js/stores/forms/LoginSignupDialogForm';
import ErrorDisplay from "js/components/common/ErrorDisplay";
import analytics from "js/services/Analytics";
import FacebookConnectButton from "js/components/common/LoginSignupDialog/FacebookConnectButton";
import GoogleConnectButton from "js/components/common/LoginSignupDialog/GoogleConnectButton";
import {GoogleLogin} from "react-google-login";
import LoginSignupDialog from "js/components/common/LoginSignupDialog";
import {EyeOpenIcon, LockIcon} from "js/components/core/Icons/Eye";
import {Link} from "@reach/router";

const noop = () => true;

export default class SPPOnboardSignup extends PageComponent {
  passwordInput = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      readMore: true,
      errorMessage: null,
      singleUseToken: null,
      showPassword: false,
    }
    this.page = FormState.create();
  }
  pageName = 'SPPOnboardSignup';
  redirect = (link) => navigate(url(link?link:'psp-onboard','',''))

  togglePasswordVisibility = () => {
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };
  pageEvent = () => {
    if (AppUser.isLoggedIn){
      // console.log("Already logged in, redirect to onboard page")
      this.redirect('psp-onboard-signup-success')
    }
  }
  formState = FormState.create();

  after = (response) => {
    // console.log("response",response);
    return (noop)(AppUser.email);
  };

  buttonCTA = (cta,link) => {
    if (AppUser.isLoggedIn){
      this.redirect(link)
    }else{
      console.info("login required")
    }
  }

  formSubmitted = (event, errors, formValues) => {
    event.preventDefault();
    this.formState.clearError();
    const PSP_SELLER_ALIAS = localStorage.getItem('PSP_SELLER_ALIAS')
    if (PSP_SELLER_ALIAS){
      formValues.psp_principal = PSP_SELLER_ALIAS;
    }else{
      formValues.psp_principal = null;
    }
    if (!errors.length && !this.formState.requestInProgress){
      this.formState.setIsRequesting();
      this.formValues = formValues;

      const prefix = analytics.loginPrefix();
      analytics
        .track(`CTA_${prefix}signup_email`, {
          'Email': formValues.email,
          'Signup Method': 'Manual',
          'Name': 'SPPOnboardSignup',
          'Address': window.location.href,
          'Position': AppState.currentPage.indexOf('LandingPage') !== -1 ? 'landing' : window.location.href,
          'Event Initiated by':  'seller',
        });
      formValues.registration_type = 'seller';

      AppUser.loginUser(null, formValues,'register')
        .then(this.after)
        .catch(error => {
          this.formState.setIsRequesting(false);
          console.log(error);
          if (error.response && error.response.data && error.response.data.message) {
            this.formState.setError(error.response.data.message);
            this.setState({errorMessage: error.response.data.message})
            // console.log("Error set for display: ",this.state.errorMessage)
          }else{
            this.formState.setError('Invalid Credentials');
            this.setState({errorMessage: 'Invalid Credentials'})
            // console.log("Error set for display: ",this.state.errorMessage)
          }
        })
    }
  }


  renderPage() {
    const { showForm, setError, error, requestInProgress, showForgotPassword, toggleDisplay, closeSafariWarning } = this.formState;
    const before = this.props.before || noop;
    const page = this.props.page;
    const mseller = null;
    const { showPassword } = this.state;
    const alias = localStorage.getItem('ALIAS')?localStorage.getItem('ALIAS'):null;

    return (
      <AppContent className="seller-link-page" padded>
        <div className="pod-container">
          <div className="tw-mt-8 tw-mb-8 tw-flex tw-items-center tw-justify-between">
            <Link className="tw-text-black tw-text-sm" to={`/seller/${alias}`}>
              <img
                src="/images/icons/icon-left.svg"
                alt="back"
                width="18" height="18"
              />&nbsp;&nbsp;&nbsp;&nbsp;
              <span className="tw-h-[18px] tw-text-sm">
                  Back to shop {alias?alias:'Someone\'s'}
                </span>
            </Link>
            <button className="tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2 tw-text-white tw-flex-end md:tw-hidden"
                    onClick={(cta) => this.buttonCTA(cta,'/create-link')}>
              Become a seller &nbsp;
              <img
                src="/images/icons/right.svg"
                alt="shop"
                className="size-24px"
              />

            </button>
          </div>
          <div className="d-flex flex-column flex-md-row justify-content-between">
            <div className="store-container">
              <h6 className="tw-font-semibold tw-text-xl tw-text-primary">Get started</h6>
              <p className="tw-text-sm">Take your first step to becoming a seller with POD and get a chance to become a POD partner</p>
              <div className="tw-max-w-lg tw-mx-auto tw-mt-12">
                <AvForm className="tw-w-full" onSubmit={this.formSubmitted}>
                  <AvGroup className="tw-w-full">
                    <label
                      htmlFor="email"
                      className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                      Enter your email
                    </label>
                    <AvInput
                      type="email"
                      id="email"
                      name="email"
                      required validate={{ email: true }}
                      aria-describedby="tw-helper-text-explanation"
                      className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                      placeholder="Enter your email address"
                    />
                    <AvFeedback>Please enter your email address.</AvFeedback>
                  </AvGroup>
                  <AvGroup className="tw-w-full tw-mt-6" style={{ position: 'relative' }}>
                    <label
                      htmlFor="password"
                      className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                      Enter your password
                    </label>
                    <AvInput
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      name="password"
                      maxLength={72} required
                      innerRef={this.passwordInput}
                      aria-describedby="tw-helper-text-explanation"
                      className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                      placeholder="Enter your password"
                    />
                    <>
                      <div style={{ position: 'absolute', top: '70%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer' }}>
                        {showPassword
                          ? <LockIcon onClick={this.togglePasswordVisibility} />
                          : <EyeOpenIcon onClick={this.togglePasswordVisibility} />}
                      </div>
                    </>
                    <AvFeedback>Please enter your password.</AvFeedback>
                  </AvGroup>
                  <Button className="tw-bg-secondary tw-py-3 tw-w-full tw-rounded-lg tw-mt-6" type="submit"
                          isLoading={requestInProgress}>
                    {'Get started'}
                  </Button>
                  <ErrorDisplay>{this.state.errorMessage}</ErrorDisplay>
                </AvForm>
                <div className="tw-my-10 tw-flex tw-items-center">
                  <div className="tw-w-full tw-h-[1px] tw-bg-outline"></div>
                  <div className="tw-block tw-px-3 tw-text-sm tw-font-medium tw-text-[#6C7277] tw-flex-shrink-0">
                    or
                  </div>
                  <div className="tw-w-full tw-h-[1px] tw-bg-outline"></div>
                </div>
                <div>
                  <LoginSignupDialog
                    padded={undefined}
                    showButtonsOnly={true}
                  />
                </div>
              </div>
            </div>
            <div className="added-item tw-hidden md:tw-block tw-mt-10">
              {this.state.readMore ? (
                <div
                  className="carded tw-bg-primary tw-max-h-[90vh] tw-mb-16 tw-md:tw-mb-0 tw-text-white tw-rounded-[30px] tw-overflow-hidden tw-relative">
                  <div
                    className="tw-bg-[#FDAE09] size-55px tw-rounded-full tw-absolute tw-top-[-34px] tw-right-3 tw-hidden tw-md:tw-block"></div>
                  <div className="tw-md:tw-flex tw-my-6 tw-px-10 tw-hidden">
                    <span className="tw-block tw-bg-[#FDAE09] size-8px tw-rounded-full"></span>
                  </div>
                  <div className="tw-md:tw-px-12 tw-px-6 tw-py-8">
                    <h2 className="tw-text-xl tw-font-semibold">POD partner program</h2>
                    <p className="tw-text-sm tw-text-faint tw-mt-3">
                      Get accurate and updated live rates of over 38+ currencies,perform instant exchange, forward rate or quick currency conversion.
                    </p>
                    <div className="tw-mt-6">
                      <div className="tw-flex tw-items-center tw-gap-2">
                        <img
                          src="/images/icons/icon-right.png"
                          alt="icon-right"
                          className="tw-w-[10px] tw-h-[6.66px]"
                        />
                        <p className="tw-text-sm tw-text-faint tw-mt-5">Revenue sharing</p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-2 tw-mt-1">
                        <img
                          src="/images/icons/icon-right.png"
                          alt="icon-right"
                          className="tw-w-[10px] tw-h-[6.66px]"
                        />
                        <p className="tw-text-sm tw-text-faint tw-mt-5" >
                          Sell more, make more money
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-2 tw-mt-1">
                        <img
                          src="/images/icons/icon-right.png"
                          alt="icon-right"
                          className="tw-w-[10px] tw-h-[6.66px]"
                        />
                        <p className="tw-text-sm tw-text-faint tw-mt-5">Invite only</p>
                      </div>
                    </div>
                    <div className="tw-flex tw-md:tw-justify-start">
                      <button
                        className="tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8 tw-mr-5"
                        onClick={() => this.setState({ readMore: !this.state.readMore })}>
                        <span className="tw-text-sm tw-font-semibold">learn more</span>
                      </button>
                      <button className="tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8 tw-text-white"
                              onClick={(cta) => this.buttonCTA(cta,'/psp-onboard')}>
                        Become a POD seller partner &nbsp;&nbsp;
                        <img
                          src="/images/icons/right.svg"
                          alt="shop"
                          className="size-24px"
                        />

                      </button>
                    </div>
                  </div>
                  <div className="tw-md:flex tw-justify-end tw-mb-10 tw-px-10 tw-hidden">
                    <span className="tw-block tw-bg-[#AAD7E1] size-10px tw-rounded-full"></span>
                  </div>
                  <div>
                    <img
                      src="/images/ssp/bg-desktop2.png"
                      alt="bg-desktop"
                      className="tw-w-full tw-h-[300px] tw-object-cover tw-hidden tw-md:tw-block"
                    />
                    <img
                      src="/images/ssp/bg-mobile2.png"
                      alt="bg-desktop"
                      className="tw-w-full tw-h-[100px] tw-object-cover tw-md:tw-hidden"
                    />
                  </div>
                </div>
              ) : (
                <div
                  className="carded tw-bg-primary tw-pt-3 tw-max-h-[90vh] tw-mb-16 tw-md:mb-0 tw-text-white tw-rounded-[30px] tw-overflow-hidden tw-relative">
                  <div
                    className="tw-bg-[#FDAE09] size-55px tw-rounded-full tw-absolute tw-top-[-24px] tw-right-[-10px] tw-hidden tw-md:tw-block"></div>
                  <div className="tw-md:tw-px-12 tw-px-6 tw-py-8 tw-max-h-[70vh] tw-overflow-y-scroll">
                    <style jsx>{`
                ::-webkit-scrollbar {
                  width: 6px;
                }

                ::-webkit-scrollbar-track {
                  background: transparent;
                  border-radius: 30px;
                }

                ::-webkit-scrollbar-thumb {
                  background: #6d60f6;
                  border-radius: 30px;
                }

                ::-webkit-scrollbar-button {
                  display: none;
                }
              `}</style>
                    <p className="tw-text-sm tw-text-faint">
                      Welcome to the POD Partnership Program, where your success is
                      our priority! Joining our program opens up a world of
                      opportunities to take your business to new heights. Here's what
                      you need to know:
                    </p>
                    <div className="tw-mt-8">
                      <p className="tw-text-base tw-text-faint tw-mb-6">
                        What is the POD Partnership Program?
                      </p>
                      <p className="tw-text-sm tw-text-faint tw-mt-3">
                        The POD Partnership Program is a unique opportunity for
                        sellers like you to earn additional income by referring
                        businesses to join POD. As they sign up and start selling
                        through POD, you'll earn a percentage of the revenue
                        generated.
                      </p>
                    </div>
                    <div className="tw-mt-12">
                      <p className="tw-text-base tw-text-faint tw-mt-6 tw-mb-6">
                        Why join the POD Partnership Program?
                      </p>
                      <div className="tw-flex tw-items-center tw-gap-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Boost Your Earnings: Earn extra income simply by sharing
                          your unique referral link with other businesses.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Empowerment: Take control of your financial future and
                          unlock new revenue streams.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Support: Receive dedicated support from the POD team to help
                          you succeed in the program.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Flexibility: Work at your own pace and fit the program into
                          your existing schedule.
                        </p>
                      </div>
                    </div>

                    <div className="tw-mt-12">
                      <p className="tw-text-base tw-text-faint tw-mt-6 tw-mb-6">
                        How Does it Work?
                      </p>
                      <div className="tw-flex tw-items-center tw-gap-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Sign up for the POD Partnership Program.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Receive your unique referral link.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Share your link with other businesses.
                        </p>
                      </div>
                      <div className="tw-flex tw-items-center tw-gap-4 tw-mt-4">
                        <span className="tw-block tw-w-1 tw-h-1 tw-bg-faint tw-rounded-full"></span>
                        <p className="tw-text-sm tw-text-faint">
                          Earn a percentage of the revenue generated by the businesses
                          you refer.
                        </p>
                      </div>
                    </div>

                    <div className="tw-mt-6">
                      <p className="tw-text-sm tw-text-faint tw-mt-3">
                        Ready to Get Started? Joining the POD Partnership Program is
                        quick and easy. Simply sign up, start sharing your referral
                        link, and watch your earnings grow! Sign Up Now and Start
                        Earning!
                      </p>
                    </div>
                  </div>

                  <div className="tw-mb-10 tw-px-10">
                    <div className="tw-flex tw-justify-end">
                      <button
                        className="tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2.5 tw-mt-8"
                        onClick={() => this.setState({ readMore: !this.state.readMore })}>
                        <span className="tw-text-sm tw-font-semibold">Okay, Got it</span>
                      </button>
                    </div>
                    <span className="tw-block tw-bg-[#AAD7E1] size-10px tw-rounded-full"></span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </AppContent>
    );
  }
}
